<div class="input-container">
  <input
    [ngClass]="{invalid}"
    [type]="type"
    [placeholder]="placeholder"
    [ngModel]="value"
    (ngModelChange)="valueChange.emit($event)"
    class="custom-input"
    min="0"
    max="100"
  />
</div>
